import React from 'react';
import { Text } from '@fluentui/react/lib/Text';
import DialogTemplate from '../../../Common/DialogTemplate';

interface IErroresPopUp {
  onAccept: () => void;
  showDialog: boolean;
  errores: string[];
}

const ErroresPopUp = ({ onAccept, showDialog, errores }: IErroresPopUp) => {
  return (
    <DialogTemplate
      showDialog={showDialog}
      toggleShowDialog={onAccept}
      title={'Se encontraron los siguientes errores al intentar iniciar el partido'}
      onAccept={onAccept}
      hideCancelButton
      onCancel={() => {}}
      acceptText="Volver al formulario"
      cancelText=""
      minWidth={600}
    >
      <>
        {errores.map((err, idx) => {
          return <div key={idx}>- {err}</div>;
        })}
      </>
    </DialogTemplate>
  );
};

export default ErroresPopUp;
